export default __webpack_public_path__ + "static/media/slide-7.11a0dacf.jpeg";